import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  EDIT_LOGIN_USER_DATA,
  SOCIAL_LOGIN,
} from "./actionTypes"

export const loginUser = (user, history, locationState) => {
  return {
    type: LOGIN_USER,
    payload: { user, history, locationState },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = (history, locationState) => {
  return {
    type: LOGOUT_USER,
    payload: { history, locationState },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const editLoginUserData = user => {
  return {
    type: EDIT_LOGIN_USER_DATA,
    payload: user,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}
